import { MenuRoute } from '../../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the FixedAsset Dashboard sub-module.
 */
export const FIXED_ASSET_DASHBOARD_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/fixed-asset/dashboard',
    labelKey: 'FixedAsset.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetOverview'
  }
];
